// routes.js

import TwoFAVerifyContainer from "../containers/2FAVerifyContainer";
import AuthContainer from "../containers/AuthContainer";
import PatientFormContainer from "../containers/PatientFormContainer";
import FormCompletion from "../containers/PatientFormContainer/Forms/FormCompletion";
import PatientFormList from "../containers/PatientFormContainer/PatientFormList";
import PdfResultContainer from "../containers/PdfResultContainer/PdfResultContainer";
import SelfRegisterContainer from "../containers/SelfRegisterContainer";
import VerificationFormLogin from "../containers/VerificationLogin/VerificationFormLogin";
import UnifiedPatientStart from "../containers/UnifiedPatientSession/UnifiedPatientStart";
import UnifiedComplete from "../containers/UnifiedPatientSession/UnifiedComplete";
import TermsOfUsePage from "../containers/TermsOfUseContainer/TermsOfUsePage";
import PrivacyAndPolicy from "../containers/PrivacyAndPolicyContainer/PrivacyAndPolicy";

const defaultConfig = {
  layoutType:'Default',
  routeType:'Public'
}
const PublicRoutes = [
    {
        path: '/login/*',
        // exact: true,
        element:AuthContainer,
        // element: <AuthContainer />,
        ...defaultConfig
      },
      {
        path: "/self-register/*",
        // exact: true,
        element: SelfRegisterContainer,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"],
        // Add more properties as needed
      },
      {
        path: "/send-questionnaire/*",
        element: VerificationFormLogin,
        ...defaultConfig,
      },
      {
        path: "/patient_form_login/*",
        exact: true,
        element: AuthContainer,
        acl: ["any"],
        layoutType: "Default",
        routeType:'Public'       
      },
      {
        path: "/kiosk/patient-form/*",
        exact: true,
        element: PatientFormContainer,
        acl: ["any"],
        layoutType: "Kiosk Patient Form",
        routeType:'Other'       
      },
      {
        path: "/patient_form/*",
        exact: true,
        element: PatientFormContainer,
        acl: ["any"],
        layoutType: "Patient Form",
        routeType:'Other'       
      },
      {
        path: "patient-form-list/patient_form/*",
        exact: true,
        element: PatientFormContainer,
        acl: ["any"],
        layoutType: "App",
        routeType:'Auth'       
      },
      {
        path: "/patient-form-list/*",
        exact: true,
        element: PatientFormList,
        acl: ["any"],
        layoutType: "App",
        routeType:'Auth'       
      },
      {
        path: "/pdf-result/*",
        exact: true,
        element: PdfResultContainer,
        acl: ["any"],
        layoutType: "Default",
        routeType:'Public'       
      },
      {
        path: "/2fa-verify/*",
        exact: true,
        element: TwoFAVerifyContainer,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"], 
      },
      {
        path: "/two-factor-authentication*",
        exact: true,
        element: TwoFAVerifyContainer,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"], 
      },
      {
        path: "/formcompleted*",
        exact: true,
        element: FormCompletion,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"], 
      },
      {
        path: "/patient-start*",
        exact: true,
        element: UnifiedPatientStart,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"],
      },
      {
        path: "/patient-complete*",
        exact: true,
        element: UnifiedComplete,
        ...defaultConfig,
        routeType:'Other',
        acl: ["any"], 
      },
      {
        path: "/terms-of-use",
        exact: true,
        element: TermsOfUsePage,
        layoutType: "Terms",
        routeType: "Other",
        acl: ["any"],
      },
      {
        path: "/privacy-policy",
        exact: true,
        element: PrivacyAndPolicy,
        layoutType: "Terms",
        routeType: "Other",
        acl: ["any"],
      },

  ];


export default PublicRoutes;